import classes from "./AuthBlock.module.css"
import "@fontsource/roboto";
import AuthImage from "./authImage/AuthImage";
import Notifications from "../popupNotifications/Notifications";
import TitleMain from "../titleMain/TitleMain";

const AuthBlock = ({ children, yandexOAuth, keycloakOAuth, onAdminClick, setTokenInfo, setUserInfo, ...props }) => {

    const sizeContainer = 5
    const sizeIcon = 4

    return (
        <div className={classes.main__block__auth__style}>
            <TitleMain text={"Авторизоваться"} jsc="center" className={classes.title__main__style} />
            <div className={classes.auth__button__style}>
                <div onClick={yandexOAuth}>
                    <AuthImage style={{ width: `${sizeIcon}vw`, height: `${sizeIcon}vw` }} widthContainer={`${sizeContainer}vw`} heightContainer={`${sizeContainer}vw`} img={"https://disk.yandex.ru/i/qDztvuZ3OfkPXA"} />
                    <span>Яндекс</span>
                </div>
            </div>
            {onAdminClick && (
                <div className={classes.admin__button__style}>
                    <button onClick={onAdminClick} className={classes.admin__button}>
                        Администратор
                    </button>
                </div>
            )}
            <Notifications />
        </div>

    )
}

export default AuthBlock